import { defineStore, storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import {
  getV8ExtraServerGlobalFilterGet,
  postV8ExtraServerGlobalFilter,
} from '@/api-client/metav8Over/queries/extra-v8-controller/extra-v8-controller';
import { FRAME_NAMES } from '@/common/define/apiTrace.define';
import type { ExternalVariablesOptions } from '@/dashboard/features/globalVariables/components/externalVariableWindow/types/externalVariableWindow.type';
import type { ExtraGlobalFilterRequest } from '@/api-client/metav8Over/model/extra-global-filter-request';
import { useDashboardViewStore } from '@/dashboard/stores/dashboard-view';

export const useExternalVariablesStore = defineStore('externalVariables', () => {
  const { monitoringDashboard } = storeToRefs(useDashboardViewStore());
  const dashboardId = computed(() => monitoringDashboard.value.dashboardId);

  const externalVariables = ref<ExternalVariablesOptions[]>([]);
  const isFetching = ref(false);

  const fetchExternalVariables = async () => {
    isFetching.value = true;
    try {
      const response = await getV8ExtraServerGlobalFilterGet(
        { dashboardId: dashboardId.value },
        {
          params: {
            frameName: FRAME_NAMES.DASHBOARD_EXTERNAL_VARIABLES.EXTRA_GLOBAL_VARIABLES,
          },
        },
      );

      const { data } = response.data;
      if (!data) {
        return;
      }

      externalVariables.value = data.map(({ options, ...rest }) => {
        return {
          ...rest,
          ...JSON.parse(options || '{}'),
        };
      });
    } catch (error) {
      console.log(error);
    } finally {
      isFetching.value = false;
    }
  };

  const setExternalVariables = (list: ExternalVariablesOptions[]) => {
    externalVariables.value = list;
  };

  const saveExternalVariables = async (request: ExtraGlobalFilterRequest) => {
    try {
      await postV8ExtraServerGlobalFilter(request, {
        params: {
          frameName: FRAME_NAMES.DASHBOARD_EXTERNAL_VARIABLES.EXTRA_GLOBAL_VARIABLES_UPDATE,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  return {
    externalVariables,
    isFetching,
    fetchExternalVariables,
    setExternalVariables,
    saveExternalVariables,
  };
});
